import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import Switch from "react-switch";
import axiosInstance from "services/axiosInstance";
import { useTheme } from "styled-components";
import * as S from "./styled";
//Components
import { useEffect, useState } from "react";
import LayoutModal from "../../../LayoutModal";
//hooks
import apiRequest from "../../../../hooks/apiRequest";
import useLoading from "../../../../hooks/useLoading";
//Interface
import { ILab } from "Interfaces/ILaboratory";
import { ILens, Inputs } from "Interfaces/ILens";
import { ICreate } from "Interfaces/ICreate";
//Icons
import { Calculator } from "@phosphor-icons/react";

export default function CreateLens({
  isOpenModal,
  setModalClose,
  refreshFrames,
  setToastOpen,
  setToastData
}: ICreate) {
  const {
    register,
    reset,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm<Inputs>();
  const theme = useTheme();
  const [treatment, setTreatment] = useState<ILens['treatment'][]>([]);
  const [typeLens, setTypeLens] = useState<ILens['type_lens'][]>([]);
  const [sensitivity, setSensitivity] = useState<ILens["sensitivity"][]>([]);
  const [surfacing, setSurfacing] = useState<ILens["surfacings"][]>([]);
  const [diameter, setDiameter] = useState<ILens["diameters"][]>([]);
  const [index, setIndex] = useState<ILens["indices"][]>([]);
  const [height, setHeight] = useState<ILens["heights"][]>([]);
  const [laboratory, setLaboratory] = useState<ILab[]>([]);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [filterBlue, setFilterBlue] = useState(false);
  const [lensName, setLensName] = useState("");
  const [lensDetails, setLensDetails] = useState({
    type_lens: "",
    surfacing: "",
    index: "",
    treatment: "",
    sensitivity: "",
    filter: "",
  });

  const fetchData = async () => {
    try {
      const [
        responseTreat,
        responseType,
        responseSens,
        responseLab,
        responseSurfacing,
        responseDiameter,
        responseIndex,
        responseheight,
      ] = await Promise.all([
        axiosInstance.get(`treatment`),
        axiosInstance.get(`type-lens`),
        axiosInstance.get(`sensitivity`),
        axiosInstance.get(`laboratory`),
        axiosInstance.get(`surfacing`),
        axiosInstance.get(`diameter`),
        axiosInstance.get(`index`),
        axiosInstance.get(`height`),
      ]);
      setTreatment(responseTreat.data);
      setTypeLens(responseType.data);
      setSensitivity(responseSens.data);
      setLaboratory(responseLab.data);
      setSurfacing(responseSurfacing.data);
      setDiameter(responseDiameter.data);
      setIndex(responseIndex.data);
      setHeight(responseheight.data);
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  useEffect(() => {
    if (isOpenModal) {
      fetchData();
    }
  }, [isOpenModal]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const payload = {
        ...data,
        filter: filterBlue,
      };
      const response = await apiRequest(`lens`, "POST", payload);
      const status = response.status;
      if (status === 201) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setToastOpen(true);
        refreshFrames();
        onClose();

      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
    reset();
    setFilterBlue(false);

    setLensDetails({
      type_lens: "",
      surfacing: "",
      index: "",
      treatment: "",
      sensitivity: "",
      filter: "",
    });
    setLensName("");
  };

  const handleSelectInput = (
    event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
    type: string,
  ) => {

    const value =
      event.target instanceof HTMLSelectElement
        ? event.target.selectedOptions[0]?.text
        : event.target.value;
    const value_id = event.target.value;

    if (value_id !== "") {

      setLensDetails((prevDetails) => {
        const updatedDetails = { ...prevDetails, [type]: value };

        // Montar o nome da lente dinamicamente
        const newLensName = [
          updatedDetails.type_lens,
          updatedDetails.surfacing,
          updatedDetails.index,
          updatedDetails.treatment,
          updatedDetails.sensitivity,
          updatedDetails.filter,
        ]
          .filter(Boolean) // Remove valores vazios
          .join(" - "); // Separa por ' - '

        setLensName(newLensName);

        setValue('name_lens', newLensName);
        return updatedDetails;
      });
    } else {
      setLensDetails((prevDetails) => {
        const updatedDetails = { ...prevDetails, [type]: '' };

        // Montar o nome da lente dinamicamente
        const newLensName = [
          updatedDetails.type_lens,
          updatedDetails.surfacing,
          updatedDetails.index,
          updatedDetails.treatment,
          updatedDetails.sensitivity,
          updatedDetails.filter,
        ]
          .filter(Boolean) // Remove valores vazios
          .join(" - "); // Separa por ' - '

        setLensName(newLensName);

        setValue('name_lens', newLensName);
        return updatedDetails;
      });
    }

  };

  const CalculateValues = () => {
    const custo = Number(watch("cost") || 0);
    const valueVenda = Number(watch("price") || 0); // Valor da venda
    const lucro = Number(watch("profit") || 0);

    // Verificar se os campos obrigatórios estão preenchidos
    if (!custo) {
      alert(
        "Para realizar o cálculo, é necessário informar o custo!"
      );
      return; // Interrompe a execução caso os valores sejam inválidos
    }

    // Caso 1: Calcular o lucro
    if (valueVenda && !lucro) {
      const calculatedLucro = ((valueVenda - custo) / custo) * 100;
      setValue("profit", calculatedLucro); // Atualiza o campo de lucro
      return;
    }

    // Calcular o resultado com lucro
    const resultLucro = custo + (custo * lucro) / 100;

    setValue("price", resultLucro.toString());
  };

  if (isOpenModal) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Lente"
        subTitle="Cadastre uma nova lente em sua base de dados."
        setModalClose={onClose}
        submiteModal={handleSubmit(onSubmit)}

        nameIconMinimize={'Registrar Lente'}
        setMaximizeModal={fetchData}
      >
        <S.Container>
          <S.FormsSection>
            <S.HeaderSection>
              Informações Básicas
            </S.HeaderSection>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Tipo de Lente
                  <span>*</span>
                </S.Label>
                <S.Select
                  {...register("type_lens_id", { required: true })}
                  onChange={(e) => handleSelectInput(e, 'type_lens')}>

                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {typeLens.map((val) => {
                    return <option value={val.id}>{val.type_lens}</option>;
                  })}
                </S.Select>
                {errors.type_lens_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Surfaçagem
                </S.Label>
                <S.Select
                  {...register("surfacing_id")}
                  onChange={(e) => handleSelectInput(e, 'surfacing')}
                >
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  <option value="">
                    NENHUM
                  </option>
                  {surfacing.map((val) => {
                    return <option value={val.id}>{val.surfacing}</option>;
                  })}
                </S.Select>
                {errors.surfacing_id && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Índice
                  <span>*</span>
                </S.Label>
                <S.Select
                  {...register("index_id", { required: true })}
                  onChange={(e) => handleSelectInput(e, 'index')}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {index.map((val) => (
                    <option key={val.id} value={val.id}>
                      {val.index}
                    </option>
                  ))}
                </S.Select>
                {errors.index_id && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Antirreflexo
                  <span>*</span>
                </S.Label>
                <S.Select
                  {...register("treatment_id", { required: true })}
                  onChange={(e) => handleSelectInput(e, 'treatment')}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {treatment.map((val) => {
                    return <option value={val.id}>{val.treatment}</option>;
                  })}
                </S.Select>
                {errors.treatment_id && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Fotossensibilidade
                </S.Label>
                <S.Select
                  {...register("sensitivity_id")}
                  onChange={(e) => handleSelectInput(e, 'sensitivity')}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  <option value="">
                    NENHUM
                  </option>
                  {sensitivity.map((val) => {
                    return (
                      <option value={val.id}>
                        {val.sensitivity}
                      </option>
                    );
                  })}
                </S.Select>
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Filtro Azul
                </S.Label>

                <Switch
                  onChange={(checked: any) => {
                    setFilterBlue(checked);
                    handleSelectInput(
                      {
                        target: {
                          value: checked ? "Filtro Azul" : "",
                        },
                      } as unknown as React.ChangeEvent<HTMLInputElement>,
                      "filter"
                    )
                  }
                  }
                  checked={filterBlue}
                  offColor={theme.colors.gray.gray_200}
                  onColor={theme.colors.gray.gray_100}
                  onHandleColor={theme.colors.primary}
                  handleDiameter={20}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                />
              </S.FormInput>
            </S.SeparateDiv>

            <S.FormInput>
              <S.Label>
                Nome da Lente
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome da lente"
                type="text"
                {...register("name_lens", { required: true })}
                value={lensName}
                onChange={(e) => setLensName(e.target.value)}
              />
              {errors.name_lens && <S.InforErro>Campo Obrigatório</S.InforErro>}
            </S.FormInput>
          </S.FormsSection>

          <S.FormsSection>
            <S.HeaderSection>
              Faixa de Graus
            </S.HeaderSection>
            <S.FormInput>
              <S.Label>
                Esferico
                <span>*</span>
              </S.Label>
              <S.SeparateDiv>
                <S.FormInput>
                  <S.Input
                    placeholder="0.0"
                    type="number"
                    {...register("spherical_start", { required: true })}
                  />
                  {errors.spherical_start && <S.InforErro>Campo Obrigatório</S.InforErro>}
                </S.FormInput>
                <S.Label>até</S.Label>

                <S.FormInput>
                  <S.Input
                    placeholder="0.0"
                    type="number"
                    {...register("spherical_end", { required: true })}
                  />
                  {errors.spherical_end && <S.InforErro>Campo Obrigatório</S.InforErro>}
                </S.FormInput>
              </S.SeparateDiv>
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Cilindro
              </S.Label>
              <S.SeparateDiv>
                <S.FormInput>
                  <S.Input
                    placeholder="0.0"
                    type="number"
                    {...register("cylindrical_start")}
                  />
                </S.FormInput>
                <S.Label>até</S.Label>
                <S.FormInput>
                  <S.Input
                    placeholder="0.0"
                    type="number"
                    {...register("cylindrical_end")}
                  />
                </S.FormInput>
              </S.SeparateDiv>
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Adição
              </S.Label>
              <S.SeparateDiv>
                <S.FormInput>
                  <S.Input
                    placeholder="0.0"
                    type="number"
                    {...register("addition_start")}
                  />
                </S.FormInput>

                <S.Label>até</S.Label>

                <S.FormInput>
                  <S.Input
                    placeholder="0.0"
                    type="number"
                    {...register("addition_end")}
                  />
                </S.FormInput>
              </S.SeparateDiv>
            </S.FormInput>
          </S.FormsSection>

          <S.FormsSection>
            <S.HeaderSection>
              Especificações Técnicas
            </S.HeaderSection>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Diâmetro
                </S.Label>
                <S.Select
                  {...register("diameter_id")}
                  onChange={(e) => handleSelectInput(e, 'diameter_id')}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  <option value="">
                    NENHUM
                  </option>
                  {diameter.map((val) => {
                    return <option value={val.id}>{val.diameter}</option>;
                  })}
                </S.Select>
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Altura
                </S.Label>
                <S.Select
                  {...register("height_id")}
                  onChange={(e) => handleSelectInput(e, 'height_id')}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  <option value="">
                    NENHUM
                  </option>
                  {height.map((val) => {
                    return <option value={val.id}>{val.height}</option>;
                  })}
                </S.Select>
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Lente laboratório
                </S.Label>
                <S.Input placeholder="Informe o nome da lente do laboratório" {...register("laboratory_lens")} />
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Laboratório
                  <span>*</span>
                </S.Label>
                <S.Select {...register("laboratory_id", { required: true })}>
                  <option value="" disabled selected hidden>
                    Selecione
                  </option>
                  {laboratory.map((val) => {
                    return (
                      <option value={val.id}>
                        {val.laboratory}
                      </option>
                    );
                  })}
                </S.Select>
                {errors.laboratory_id && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
              <S.FormInput>
                <S.Label>
                  Prazo de entrega
                  <span>*</span>
                </S.Label>
                <Controller
                  name="delivery"
                  control={control}
                  rules={{ required: "Este campo é obrigatório" }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      decimalScale={0}
                      fixedDecimalScale={true}
                      placeholder="1 dia"
                      suffix={Number(value) > 1 ? " dias" : " dia"}
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.delivery && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>
          </S.FormsSection>

          {/* Campo de Valores */}
          <S.FormsSection>
            <S.HeaderSection>
              Informações Financeiras
              <S.ButtonCalc onClick={CalculateValues}>
                <Calculator size={18} />
              </S.ButtonCalc>
            </S.HeaderSection>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Custo R$
                  <span>*</span>
                </S.Label>
                <Controller
                  name="cost"
                  control={control}
                  rules={{ required: "Este campo é obrigatório" }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.cost && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>Lucro %</S.Label>
                <Controller
                  name="profit"
                  control={control}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="0,00 %"
                      suffix=" %"
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue); // Atualiza o valor de compra
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
              </S.FormInput>
            </S.SeparateDiv>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Entrada Mínima R$
                  <span>*</span>
                </S.Label>
                <Controller
                  name="minimum_value"
                  control={control}
                  rules={{ required: "Este campo é obrigatório" }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.minimum_value && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Valor da Venda R$
                  <span>*</span>
                </S.Label>
                <Controller
                  name="price"
                  control={control}
                  rules={{ required: "Este campo é obrigatório" }}
                  render={({ field: { onChange, value, ref } }) => (
                    <NumericFormat
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale={true}
                      placeholder="R$ 0,00"
                      prefix="R$ "
                      value={value}
                      onValueChange={(values) => {
                        const purchaseValue = values.floatValue ?? 0;
                        onChange(purchaseValue);
                      }}
                      getInputRef={ref}
                    />
                  )}
                />
                {errors.price && <S.InforErro>Campo Obrigatório</S.InforErro>}
              </S.FormInput>
            </S.SeparateDiv>
          </S.FormsSection>
          {/* Fim Campo de Valores */}
        </S.Container>
      </LayoutModal >
    );
  }
  return null;
}
